/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { useEffect, useState } from 'react'

const Card = (props) => {

    const [cardImage, setCardImage] = useState('');

    const getOverviewImage = async () => {
        try {
            const res = await axios({
                method: 'GET',
                url: `${process.env.REACT_APP_SERVER_URL}/api/overview-image/${props.siteId}`
            })

            if (res && res.status === 200) {
                setCardImage(`${process.env.REACT_APP_SERVER_URL}/${res.data.data.path}`)

            }
        } catch (error) {
        }
    }

    useEffect(() => {
        getOverviewImage()
    }, [])

    return (
        <div className='col-lg-4'>
            <div className='card' >

                <div className="card-image">
                    <img alt='card-logo' src={cardImage} />
                </div>
                <div className="card-text-box">
                    <h2 className='card-heading' >{props.title}</h2>
                    {props.children}
                    <div className="card-actions">
                        <button onClick={props.onEdit} className='btn-blue-sm mb-10 w-100' >
                          <i className='fa fa-pencil'></i>  Edit
                        </button>
                        <button onClick={props.onDownload} className='btn-red-sm w-100' >
                            <ion-icon name="download-outline"></ion-icon> Download HTML
                        </button>
                    </div>
                    <button onClick={props.onDelete} className='delete-site-btn' >
                        <i className='fa fa-times'></i>
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Card;